export const trackingCategory = "Use case reselection flow";

export const skipPopupEventName = "Skip and stay on current plan";

export const SWITCH_SOLUTION_KEY = "popupSwitchSolutionAppeared";

export const switchPopupClassName = "change-solution-modal-container";

export const changeSolutionSteps = {
    welcome: "welcomeStep",
    useCase: "useCaseStep",
    currentSolution: "currentSolutionStep",
    newSolution: "newSolutionStep",
} as const;

export type ChangeSolutionStepsType = (typeof changeSolutionSteps)[keyof typeof changeSolutionSteps];

export const continueButtonText = {
    [changeSolutionSteps.welcome]: "components.shared.change_solution_modal.buttons.next",
    [changeSolutionSteps.useCase]: "components.shared.change_solution_modal.buttons.next",
    [changeSolutionSteps.currentSolution]: "components.shared.change_solution_modal.buttons.continue",
    [changeSolutionSteps.newSolution]: "components.shared.change_solution_modal.buttons.start_trial",
};
